/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FollowingInputs */

const th_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังติดตาม`)
};

const en_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Following`)
};

const ja_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォロー中`)
};

const zh_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关注中`)
};

const es_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiendo`)
};

const pt_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguindo`)
};

const id_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diikuti`)
};

const fr_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivis`)
};

const tl_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinusundan`)
};

const vi_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang theo dõi`)
};

const ko_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팔로잉`)
};

const de_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folge ich`)
};

const ru_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписки`)
};

const tr_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takip edilenler`)
};

const it_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguiti`)
};

const pl_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obserwowane`)
};

const uk_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підписки`)
};

const hi_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉलो किए गए`)
};

const ar_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المتابَعون`)
};

const ms_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diikuti`)
};

const bn_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনুসৃত`)
};

const zh_tw2_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤中`)
};

const zh_hk2_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤中`)
};

const ur_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فالو شدہ`)
};

const fa_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دنبال‌شده`)
};

const sw_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unafuatilia`)
};

const nl_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gevolgd`)
};

/**
* | output |
* | --- |
* | "Following" |
*
* @param {FollowingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const following = /** @type {((inputs?: FollowingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FollowingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_following(inputs)
	if (locale === "ja") return ja_following(inputs)
	if (locale === "zh") return zh_following(inputs)
	if (locale === "es") return es_following(inputs)
	if (locale === "pt") return pt_following(inputs)
	if (locale === "id") return id_following(inputs)
	if (locale === "fr") return fr_following(inputs)
	if (locale === "tl") return tl_following(inputs)
	if (locale === "vi") return vi_following(inputs)
	if (locale === "ko") return ko_following(inputs)
	if (locale === "de") return de_following(inputs)
	if (locale === "ru") return ru_following(inputs)
	if (locale === "tr") return tr_following(inputs)
	if (locale === "it") return it_following(inputs)
	if (locale === "pl") return pl_following(inputs)
	if (locale === "uk") return uk_following(inputs)
	if (locale === "hi") return hi_following(inputs)
	if (locale === "ar") return ar_following(inputs)
	if (locale === "ms") return ms_following(inputs)
	if (locale === "bn") return bn_following(inputs)
	if (locale === "zh-TW") return zh_tw2_following(inputs)
	if (locale === "zh-HK") return zh_hk2_following(inputs)
	if (locale === "ur") return ur_following(inputs)
	if (locale === "fa") return fa_following(inputs)
	if (locale === "sw") return sw_following(inputs)
	if (locale === "nl") return nl_following(inputs)
	return en_following(inputs)
});